<section class="reporting-page">
  <section class="reporting-content" aria-live="polite">
    <router-outlet></router-outlet>
  </section>
</section>
